import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  MediaRelationsCreateRequest,
  MediaRelationsListItem,
  MediaRelationsSuggestRequest,
  MediaRelationsSuggestResponse,
} from 'models-media-relations';

import { MEDIA_RELATIONS_API_TOKEN } from '../token';

@Injectable()
export class MediaRelationsService {
  private readonly api: string = inject(MEDIA_RELATIONS_API_TOKEN);
  private readonly http: HttpClient = inject(HttpClient);

  public getMediaRelations(includeProductInfo = true) {
    const params = new HttpParams().set(
      'includeProductInfo',
      includeProductInfo.toString(),
    );
    return this.http.get<MediaRelationsListItem[]>(this.api, { params });
  }

  public createMediaRelation(payload: MediaRelationsCreateRequest) {
    return this.http.post<MediaRelationsListItem>(`${this.api}`, payload);
  }

  public deleteMediaRelations(id: string) {
    return this.http.delete<MediaRelationsListItem>(`${this.api}/${id}`);
  }

  public updateMediaRelations(
    id: string,
    payload: MediaRelationsCreateRequest,
  ) {
    return this.http.post<MediaRelationsListItem>(`${this.api}/${id}`, payload);
  }

  public suggestMediaRelations(payload: MediaRelationsSuggestRequest) {
    return this.http.post<MediaRelationsSuggestResponse[]>(
      `${this.api}/suggest`,
      payload,
    );
  }
}
